import { render } from "./ope_elgant_confirm.vue?vue&type=template&id=2ab6ea8d&scoped=true"
import script from "./ope_elgant_confirm.vue?vue&type=script&lang=js"
export * from "./ope_elgant_confirm.vue?vue&type=script&lang=js"

import "./css/ope_elgant.scss?vue&type=style&index=0&id=2ab6ea8d&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ab6ea8d"]])

export default __exports__